import { Box, Card, Typography } from '@mui/material';
import React, { useState } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import { styles } from '../../styles/styles';
import Cmdimage from '../../homepage/Cmd.png';
import { DecorativeCorner } from '../../common/DecorativeCorner';
const Advertisement = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    setIsPlaying(true);
  };
  return (
    <>
      <Box>
        <Header />
      </Box>
      <Box
        sx={{
          marginTop: { xs: "29%", sm: "10%", md: "10%", lg: "10%", xl: "10%" },
          marginBottom: "5%"
        }}
      >     <Card
        sx={{
          ...styles.aboutcard,
          boxShadow: 3,
        }}
      >
          <DecorativeCorner sx={{ top: -20, left: -20 }} />
          <DecorativeCorner sx={{ top: -20, right: -20 }} />
          <DecorativeCorner sx={{ bottom: -20, right: -20 }} />
          <DecorativeCorner sx={{ bottom: -20, left: -20 }} />

          <Typography variant="h4" component="h1" sx={styles.heading}>
            Advertisement Video  Annapurna Marriages
          </Typography>
          <Card
            sx={{
              ...styles.aboutCard,
              boxSizing: "border-box",
              padding: "30px"
            }}
          >
            <Box sx={{ width: "100%", height: "400px", position: "relative" }}>
              {!isPlaying && (
                <Typography
                  variant="h4"
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    color: "white",
                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                    padding: "16px 32px",
                    borderRadius: "12px",
                    zIndex: 2,
                    fontWeight: "bold",
                  }}
                >
                  <Box
                    component="img"
                    src={Cmdimage}
                    alt="Career"
                    sx={{
                      width: "200px",
                      height: "250px",
                    }}
                  />
                </Typography>
              )}
              <video
                width="100%"
                height="100%"
                controls
                onPlay={handlePlay}
                poster="/path-to-thumbnail.jpg" 
                style={{ objectFit: "cover" }}
              >
                <source
                  src="https://www.annapurnamarriages.com/uploads/ANNAPURNAMARRIAGESGNT_1.mp4"
                  type="video/mp4"
                />
              not support the video 
              </video>
            </Box>
          </Card>
        </Card>
      </Box>
      <Footer />
    </>
  )
}

export default Advertisement